import { Link } from 'react-router-dom';
import { LEGAL_CONFIG } from '@/config/legal';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-gray-300 mt-auto">
      <div className="container mx-auto px-4 py-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <h2 className="text-2xl font-bold text-white mb-4">Lezzet Yolda</h2>
            <p className="text-sm leading-relaxed">
              Şehrin en seçkin restoranlarından dakikalar içinde kapınıza ulaştıran online yemek
              sipariş platformu.
            </p>
            <p className="text-xs text-gray-500 mt-3">{LEGAL_CONFIG.companyName}</p>
          </div>

          <div>
            <h3 className="font-semibold text-white mb-3">Hakkımızda</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/about" className="hover:text-white transition-colors">
                  Biz Kimiz
                </Link>
              </li>
              <li>
                <Link to="/careers" className="hover:text-white transition-colors">
                  Kariyer
                </Link>
              </li>
              <li>
                <Link to="/contact" className="hover:text-white transition-colors">
                  İletişim
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-semibold text-white mb-3">Yardım</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/faq" className="hover:text-white transition-colors">
                  SSS
                </Link>
              </li>
              <li>
                <Link to="/teslimat-iade" className="hover:text-white transition-colors">
                  Teslimat ve İade
                </Link>
              </li>
              <li>
                <Link to="/support" className="hover:text-white transition-colors">
                  Destek
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-semibold text-white mb-3">Yasal</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/mesafeli-satis-sozlesmesi" className="hover:text-white transition-colors">
                  Mesafeli Satış Sözleşmesi
                </Link>
              </li>
              <li>
                <Link to="/terms" className="hover:text-white transition-colors">
                  Kullanım Koşulları
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="hover:text-white transition-colors">
                  Gizlilik Politikası
                </Link>
              </li>
              <li>
                <Link to="/cookies" className="hover:text-white transition-colors">
                  Çerez Politikası
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Payment Logos */}
        <div className="border-t border-gray-800 mt-8 pt-6">
          <p className="text-xs text-gray-500 mb-3">Güvenli ödeme altyapısı</p>
          <div className="flex flex-wrap items-center gap-4">
            <div className="bg-white rounded-lg px-3 py-2 flex items-center justify-center">
              <img src="/logos/visa.png" alt="Visa" className="h-6 object-contain" />
            </div>
            <div className="bg-white rounded-lg px-3 py-2 flex items-center justify-center">
              <img src="/logos/mastercard.png" alt="Mastercard" className="h-6 object-contain" />
            </div>
            <div className="bg-white rounded-lg px-3 py-2 flex items-center justify-center">
              <img src="/logos/iyzico.png" alt="Iyzico ile Öde" className="h-6 object-contain" />
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-6 pt-6 flex flex-col md:flex-row justify-between items-center">
          <p className="text-sm">
            &copy; {new Date().getFullYear()} Lezzet Yolda. Tüm hakları saklıdır.
          </p>
          <div className="flex gap-4 mt-4 md:mt-0">
            <a
              href="https://twitter.com"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-white transition-colors"
            >
              Twitter
            </a>
            <a
              href="https://instagram.com"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-white transition-colors"
            >
              Instagram
            </a>
            <a
              href="https://facebook.com"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-white transition-colors"
            >
              Facebook
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
